/**
 * The notice every public form and invite-link form shows an anonymous
 * visitor, just above Send (KPR-480). One string set, because the permanent
 * public form (PublicFormPage, KPR-471) and the invite link (ShortLinkPage)
 * both render SharedFormPage and share the form definition.
 *
 * DRAFT wording, not final legal text (owner ruling 2026-10-11: the Oregon LLC
 * does not exist yet, so nothing here is published as final). Based on
 * ~/Dropbox/KEEPR/docs/legal-drafts/public-form-notice.md, with its
 * [VERIFY]/[TBD] markers kept out of the user-facing text. The privacy-policy
 * link is deliberately absent until the policy is published; add it here, in
 * one place, then. Why plain strings and not an API setting: a notice that
 * differs per collection would be a promise the owner cannot vouch for.
 */
export const FORM_NOTICE_HEADING = 'Before you send';

// A published collection: what is sent becomes visible to its readers.
export const FORM_NOTICE_PUBLISHED = [
	'What you send, including any photos, is added to a public collection and can be seen by anyone who uses it.',
	'The people who manage the collection can also see your private answers, such as your name and contact details. They are never shown with the collection.',
	'By sending, you license what you add to the collection’s managers and readers to read, keep and share.',
];

// Any other collection: nothing is published; managers see everything.
export const FORM_NOTICE_PRIVATE = [
	'What you send goes to the people who manage this collection. It is not published.',
	'They can see everything you add, including private answers such as your name and contact details.',
	'By sending, you license what you add to the collection’s managers to read, keep and share.',
];
